import type { SVGProps } from "react";

const SvgMbankLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 46.08 46.08"
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2,
    }}
    {...props}
  >
    <clipPath id="a">
      <path d="M0 0h46.08v46.08H0z" />
    </clipPath>
    <g clipPath="url(#a)">
      <path
        style={{
          fill: "#ae0000",
          fillRule: "nonzero",
        }}
        transform="scale(.36 .96)"
        d="M71.68 0h22.398v48H71.68z"
      />
      <path
        style={{
          fill: "#ff8600",
          fillRule: "nonzero",
        }}
        transform="scale(.36 .96)"
        d="M37.105 0h34.574v48H37.105z"
      />
      <path
        style={{
          fill: "#0065b1",
          fillRule: "nonzero",
        }}
        transform="scale(.36 .96)"
        d="M94.084 0h2.56v48h-2.56z"
      />
      <path
        style={{
          fill: "#e90a0a",
          fillRule: "nonzero",
        }}
        transform="scale(.36 .96)"
        d="M0 0h33.266v48H0z"
      />
      <path
        style={{
          fill: "#008f20",
          fillRule: "nonzero",
        }}
        transform="scale(.36 .96)"
        d="M96.64 0H128v48H96.64z"
      />
      <path
        style={{
          fill: "#26221e",
          fillRule: "nonzero",
        }}
        transform="scale(.36 .96)"
        d="M33.266 0h3.839v48h-3.839z"
      />
      <path
        d="M39.755 25.247v8.673h-4.393v-8c0-2.45-1.1-3.577-2.873-3.577-1.971 0-3.351 1.268-3.351 3.971v7.6h-4.393v-8c0-2.45-1.041-3.577-2.872-3.577-1.944 0-3.323 1.268-3.323 3.971v7.6h-4.393V22.149h-1.69V18.77h5.21l.225 2.338a6.03 6.03 0 0 1 5.21-2.563 5.66 5.66 0 0 1 4.988 2.478 6.81 6.81 0 0 1 5.463-2.478c3.6 0 6.2 2.084 6.2 6.7m20.999 3.297c0 3.407-2.7 5.379-7.885 5.379H43.19V17.926h-2.084v-3.717h11.208c4.928 0 7.462 2.055 7.462 5.125a4.75 4.75 0 0 1-2.619 4.336 4.884 4.884 0 0 1 3.605 4.872m-13.038-10.9v4.648h4.027c2.224 0 3.435-.788 3.435-2.337s-1.211-2.309-3.435-2.309zm8.42 10.419c0-1.661-1.24-2.45-3.6-2.45h-4.82v4.872h4.815c2.365 0 3.6-.732 3.6-2.422m22.475-9.291v15.15h-4.2v-1.746a5.83 5.83 0 0 1-4.731 1.972c-4.28 0-7.575-3.041-7.575-7.8s3.3-7.8 7.575-7.8a5.82 5.82 0 0 1 4.533 1.83V18.77zm-4.307 7.575c0-2.618-1.691-4.195-3.858-4.195h-.06c-2.108 0-3.844 1.735-3.844 3.844q0 .178.017.356a4 4 0 0 0-.017.356c0 2.109 1.736 3.844 3.844 3.844h.06c2.167 0 3.858-1.576 3.858-4.2m23.569-1.103v8.673h-4.393v-8c0-2.45-1.127-3.577-3.07-3.577-2.112 0-3.632 1.3-3.632 4.084v7.49h-4.393V22.149H80.7V18.77h5.21l.225 2.366a6.37 6.37 0 0 1 5.465-2.591c3.576 0 6.28 2.084 6.28 6.7m18.525 8.675h-4.984l-4.281-6.561h-2.028v6.561h-4.392V13.026h4.392v10.982h2.028l4.056-5.238h4.899l-5.153 6.646z"
        style={{
          fill: "#fff",
          fillRule: "nonzero",
        }}
        transform="matrix(.36 0 0 .36 -.157 14.547)"
      />
    </g>
  </svg>
);
export default SvgMbankLogo;
